import React, { Component } from 'react'
import { compose } from 'recompose'
import withSelectFetch from '../withSelectFetch'
import withSpinning from '../../HOC/withSpinning'
import CustomSelect from '../CustomSelect'
import withSort from '../../HOC/withSort'
import withSubDropdown from '../../HOC/withSubDropdown'

class TaxType extends Component {
  render() {
    return <CustomSelect placeholder={'Tax Type'} {...this.props} />
  }
}

const TaxTypeSelect = compose(
  withSelectFetch({ dropdown: 'lines', name: 'tax' }),
  withSpinning,
  withSubDropdown({ name: 'type' }),
  withSort
)(TaxType)

export default TaxTypeSelect
